"use client"

const DeleteAdminModal = ({ show, admin, onConfirm, onClose, isLoading }) => {
  if (!show || !admin) return null

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Delete Admin</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={isLoading}></button>
          </div>
          <div className="modal-body">
            <p className="mb-0">
              Are you sure you want to delete <strong>{admin.fullname}</strong>?
            </p>
            <p className="text-muted small mt-2">
              Email: <strong>{admin.email}</strong>
            </p>
            <div className="alert alert-warning mt-3 mb-0">
              <small>This action cannot be undone.</small>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isLoading}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? "Deleting..." : "Delete Admin"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteAdminModal
